import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { LoadingController, ToastController } from '@ionic/angular';

@Component({
  selector: 'app-tab4',
  templateUrl: 'tab4.page.html',
  styleUrls: ['tab4.page.scss']
})
export class Tab4Page {
    loading:any
    contents:any = [];
    alert_status:any;
    alert_message:any;
    constructor(public toastController: ToastController,private http: HttpClient,private loadingCtrl: LoadingController) {}

  ionViewWillEnter(){
    this.presentLoading();
    this.http.get("https://api.infoparkingamalfi.com/elevator/status").subscribe(async res=>{
      //this.http.get("http://localhost:5001/elevator/status").subscribe(async res=>{
      await this.hideLoading();
      this.contents = res;
      this.http.get("https://api.infoparkingamalfi.com/elevator/status/alert").subscribe( data_alert => {
      //this.http.get("http://localhost:5001/elevator/status/alert").subscribe( data_alert => {
      this.alert_status = data_alert[0].status;
      this.alert_message = data_alert[0].message;
      });
    })
  }

  async presentToast(resource: any = {}) {

    const closeButton = {
      side: 'end', 
      role: 'close', 
      icon: 'close',
      handler: () => {},
    };

    if(resource.hasOwnProperty('canDismiss')){
      resource['duration'] = 0;
      if(resource['buttons'] && resource['buttons'].length > 0){
        resource['buttons'].push(closeButton)
      }else{
        resource['buttons'] = [
          closeButton
        ];
      }
    }

    if(!resource.hasOwnProperty('duration')){
      resource['duration'] = 6000;
    }

    const toast = await this.toastController.create({
      cssClass: 'ion-custom-toast',
      header: resource?.header || '',
      message: resource?.message || '',
      duration: resource.duration,
      position: resource?.position || 'top',
      color: resource?.color || 'dark',
      buttons: resource?.buttons || [],
      
    });
    await toast.present();

    const { role } = await toast.onDidDismiss();
    if (resource.callback) {
      resource.callback(role);
    }
  }


  async presentLoading(message = "Please Wait...") {
    this.loading = await this.loadingCtrl.create({
      spinner: 'lines-small',
      message: message,
      translucent: true,
      cssClass: 'custom-class custom-loading'
    });
    await this.loading.present();
  }

  async hideLoading() {
    await this.loading.dismiss();
  }
}
